import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.69 5.772l-.243.123a1 1 0 1 1-.895-1.79l2-1a.998.998 0 0 1 1.434 1.06l-1 6a1 1 0 1 1-1.973-.33l.677-4.063zm-5.073-.848a.997.997 0 0 1-.324-.217l-1-1a1 1 0 0 1 1.414-1.414l1 1a.999.999 0 0 1-1.09 1.631zm10.766 0a.997.997 0 0 1-.94-.092 1 1 0 0 1-.15-1.54l1-1a1 1 0 1 1 1.414 1.415l-1 1a.996.996 0 0 1-.324.217zm-.09 3.783A1 1 0 0 1 16 7h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-.707-.293zM4 9H2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2zm-3 8.5V12h2v2h3.5c.775 0 1.388.662 1.926 1.244l.11.12a2 2 0 0 0 2.927-.001l.11-.119h.001C12.112 14.662 12.725 14 13.5 14H17v-2h2v5.5a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5z"
});

var SvgFirstOrderMajor = function SvgFirstOrderMajor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgFirstOrderMajor as S };
